<template>
  <div id="app-31">
    <LmsMssComponent endpoint="gettaf" source="data" header_filter="FTSQ31" show_header="true" />
  </div>
</template>

<script>
import LmsMssComponent from "@/components/LmsMssComponent";

export default {
  name: 'app',
  components: {
    LmsMssComponent,
  }
}
</script>
